<template>
  <div>
    <h1>Рецепты</h1>
    <RecipeList />
  </div>
</template>

<script>
import RecipeList from "../RecipeList.vue";

export default {
  name: "PageRecieps",
  components: {
    RecipeList,
  },
};
</script>

<style scoped></style>
